export default __webpack_public_path__ + "directory-bdm-800-49c608f3cb5147937c54a00273c687ed.webp";